<template>
    <div>
        <hr>
        <b-row align-h="between">
            <b-col cols="12" md="6">
                <div class="pb-4"><b>Comentario de la Orden:</b></div>
                <div v-if="data.comentario !== null">
                    {{data.comentario}}
                </div>
                <div v-else>
                    Sin comentarios.
                </div>
            </b-col>
            <b-col cols="12" md="4">
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <th class="text-end">Subtotal Bruto:</th>
                            <td><b>$ {{numberFormat(data.subtotal_bruto)}}</b></td>
                        </tr>
                        <tr v-if="data.descuento > 0">
                            <th class="text-end">Descuento:</th>
                            <td><b>$ {{numberFormat(data.descuento)}}</b></td>
                        </tr>
                        <tr>
                            <th class="text-end">Subtotal Neto:</th>
                            <td><b>$ {{numberFormat(data.subtotal_neto)}}</b></td>
                        </tr>
                        <tr>
                            <th class="text-end">IVA:</th>
                            <td><b>$ {{numberFormat(data.impuesto)}}</b></td>
                        </tr>
                        <tr>
                            <th class="text-end blue--text">Monto Total:</th>
                            <td class="blue--text"><b>$ {{numberFormat(data.total_precio)}}</b></td>
                        </tr>
                    </tbody>
                </table>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: "ItemsFooter",
    props: {
        data: {
            type: Object
        }
    }
};

</script>
<style scoped>

</style>